module.exports = __webpack_public_path__ + "static/proptech-7ce2bb53865b1a9858f191bc7f8a9e91.png";